import { Props } from './interface'
import * as Styled from './styled'

function Radio({ name, label, register, value }: Props) {
  return (
    <Styled.Wrapper>
      <Styled.Radio
        id={String(value)}
        name={name}
        value={value}
        type="radio"
        {...register?.(name)}
      />
      <Styled.Label htmlFor={String(value)}>{label}</Styled.Label>
    </Styled.Wrapper>
  )
}

export default Radio
